import script from "./9DCT.vue?vue&type=script&setup=true&lang=js"
export * from "./9DCT.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__